import { RouterView } from 'vue-router'

export const reportsRoutes = [
  {
    path: 'reports',
    component: () => import('@/modules/reports/views/GenericReportsView.vue'),
    children: [
      {
        path: 'sales',
        component: RouterView,
        children: [
          {
            name: 'organizationReportBilling',
            path: 'billing',
            component: () =>
              import('@/modules/reports/views/sales/OrganizationReport.vue')
          },

          // Location Routes
          {
            name: 'simplifiedBillingReport',
            path: '/reporting/simplified-billing',
            component: () =>
              import(
                '@/modules/reports/views/sales/SimplifiedBillingReport.vue'
              )
          },
          {
            name: 'revenueSources',
            path: 'sources',
            component: () =>
              import('@/modules/reports/views/sales/RevenueSources.vue')
          },
          {
            name: 'activity',
            path: 'activity',
            component: () =>
              import('@/modules/reports/views/sales/ActivityReport.vue')
          },
          {
            name: 'promotionsReport',
            path: 'promotions',
            component: () =>
              import('@/modules/reports/views/sales/PromotionsReport.vue')
          },
          {
            name: 'fraudReport',
            path: 'fraud-control',
            component: () =>
              import('@/modules/reports/views/sales/FraudReport.vue')
          }
        ]
      },
      {
        path: 'catalog',
        component: RouterView,
        children: [
          {
            name: 'productsOrganizationReport',
            path: 'products',
            component: () =>
              import('@/modules/reports/views/catalog/ProductsReport.vue'),
            props: { scope: 'organization' }
          },
          {
            name: 'modifiersOrganizationReport',
            path: 'modifiers',
            component: () =>
              import('@/modules/reports/views/catalog/ModifiersReport.vue'),
            props: { scope: 'organization' }
          },
          {
            name: 'combosOrganizationReport',
            path: 'combos',
            component: () =>
              import('@/modules/reports/views/catalog/CombosReport.vue'),
            props: { scope: 'organization' }
          },
          {
            name: 'productsLocationReport',
            path: 'products',
            component: () =>
              import('@/modules/reports/views/catalog/ProductsReport.vue'),
            props: { scope: 'location' }
          },
          {
            name: 'categories',
            path: 'categories',
            component: () =>
              import('@/modules/reports/views/catalog/CategoriesReport.vue'),
            props: { scope: 'location' }
          },
          {
            name: 'modifiersLocationReport',
            path: 'modifiers',
            component: () =>
              import('@/modules/reports/views/catalog/ModifiersReport.vue'),
            props: { scope: 'location' }
          },
          {
            name: 'combosLocationReport',
            path: 'combos',
            component: () =>
              import('@/modules/reports/views/catalog/CombosReport.vue'),
            props: { scope: 'location' }
          }
        ]
      },
      {
        path: 'performance',
        component: RouterView,
        children: [
          {
            name: 'ratings',
            path: 'ratings',
            component: () =>
              import('@/modules/reports/views/performance/RatingsReport.vue'),
            props: { scope: 'organization' }
          },
          {
            name: 'employeesReport',
            path: 'employees',
            component: () =>
              import('@/modules/reports/views/performance/EmployeesReport.vue')
          },
          {
            name: 'deliveryOrderStatusesReport',
            path: 'statuses',
            component: () =>
              import(
                '@/modules/reports/views/performance/DeliveryOrderStatusReport.vue'
              )
          },
          {
            name: 'ratingsLocationReport',
            path: 'ratings',
            component: () =>
              import('@/modules/reports/views/performance/RatingsReport.vue'),
            props: { scope: 'location' }
          }
        ]
      },
      {
        path: 'financial-records',
        component: RouterView,
        children: [
          // Organization routes
          {
            name: 'tabsOrganizationReport',
            path: 'tabs/:id?',
            component: () =>
              import('@/modules/reports/views/financialRecords/TabsReport.vue'),
            props: { scope: 'organization' }
          },
          {
            name: 'invoices',
            path: 'invoices',
            component: () =>
              import(
                '@/modules/reports/views/financialRecords/InvoicesReport.vue'
              ),
            props: { scope: 'organization' }
          },
          {
            name: 'datevExport',
            path: 'datev-export',
            component: () => 
              import('@/modules/reports/views/financialRecords/DatevExport.vue')
          },
          {
            name: 'movements',
            path: 'movements',
            component: () =>
              import(
                '@/modules/reports/views/financialRecords/MovementsReport.vue'
              ),
            props: { scope: 'organization' }
          },

          // Location routes
          {
            name: 'tabsLocationReport',
            path: 'location-tabs/:id?',
            component: () =>
              import('@/modules/reports/views/financialRecords/TabsReport.vue'),
            props: { scope: 'location' }
          },
          {
            name: 'cashReport',
            path: 'cash',
            component: () =>
              import('@/modules/reports/views/financialRecords/CashReport.vue')
          },
          {
            name: 'invoicesLocationReport',
            path: 'location-invoices',
            component: () =>
              import(
                '@/modules/reports/views/financialRecords/InvoicesReport.vue'
              ),
            props: { scope: 'location' }
          },
          {
            name: 'movementsLocationReport',
            path: 'location-movements',
            component: () =>
              import(
                '@/modules/reports/views/financialRecords/MovementsReport.vue'
              ),
            props: { scope: 'location' }
          }
        ]
      },
      {
        name: 'explore',
        path: 'explore',
        component: () => import('@/modules/reports/views/common/Explore.vue')
      },
      {
        name: 'custom',
        path: 'custom/:reportId',
        component: () =>
          import('@/modules/reports/views/common/CustomReport.vue'),
        meta: {
          allowedRoles: ['organization', 'singleLocation']
        }
      }
    ]
  }
]
